import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { toast } from "react-hot-toast";
import RefineryForm from "./RefineryForm";
import { showRefinery } from "../erpClient";
import {
  isRefineryApiSuccess,
  mapRefineryShowToForm,
} from "../utils/refineryErpAdapter";

function EditRefinery() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await showRefinery({ id: Number(id) });
        if (!isRefineryApiSuccess(res)) {
          toast.error(res?.message || "Failed to load refinery bill");
          navigate("/refinery");
          return;
        }
        const mapped = mapRefineryShowToForm(res);
        if (!mapped) {
          toast.error("Refinery bill not found");
          navigate("/refinery");
          return;
        }
        if (!cancelled) setInitialData(mapped);
      } catch (e) {
        console.error(e);
        toast.error("Failed to load refinery bill");
        navigate("/refinery");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="body-wrapper d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return <RefineryForm mode="edit" initialData={initialData} />;
}

export default EditRefinery;
